import styled from '@emotion/styled'
import type { FormItemProps } from '@vivaldis/antd-ui'
import { AiSuggestedTag } from '../AiSuggestedTag'

interface LabelWithAISuggestionProps {
  // typed from antd's public Form.Item props, so changes in antd surface as TS errors
  label: FormItemProps['label']
  aiSuggested?: boolean
}

// Used as Form.Item `label`. Form.Item keeps its `tooltip` prop: antd renders the tooltip icon
// as a sibling after this node inside its <label> (inline-flex). `display: contents` makes our
// children flex items of that <label>, so `order` moves the AI tag after the icon.
// The <label> is stretched to full width via `:has()`, so the tag can sit at the right edge.
export const LabelWithAISuggestion = ({
  label,
  aiSuggested = false
}: LabelWithAISuggestionProps) => {
  return (
    <Container>
      <span>{label}</span>
      {aiSuggested ? <RightAlignedAiSuggestedTag /> : null}
    </Container>
  )
}

const Container = styled('span')`
  display: contents;

  .ant-form-item-label > label:has(> &) {
    width: 100%;
  }
`

const RightAlignedAiSuggestedTag = styled(AiSuggestedTag)`
  order: 1;
  margin-left: auto;
`
